import React from "react";
import "./SearchBoxContainer.css";
import {getMainCharacterData} from "../includes/axios/getMainCharacterData.js";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router,withRouter} from "react-router-dom";
import { Redirect } from 'react-router';

var SearchBox = class SearchBox extends React.Component{
    constructor(props){
        super(props);
        //use this as a local State to control the text box. When the button is clicked
        //we pass this value into grabHero(changeCharacter) which puts it into the Store's state
        this.state = {
          search: "",
          redirect: false
        }
        
        //changeCharacter() and changeFeaturedComics() are reducers. 
        //Its passed down attached to this.props from App->headerContainer->here
        this.changeCharacter = this.props.changeCharacter;
        this.changeFeaturedComics = this.props.changeFeaturedComics;
        this.changeRelatedCharacters = this.props.changeRelatedCharacters;
        this.showFeaturedArea = this.props.showFeaturedArea;
        this.showComicArea = this.props.showComicArea;
    }//end constructor()
    
    updateSearchText(event){
        this.setState({
          search:event.target.value
        });
        
    }

    handleKeyPress(e,currentCharacterInfo) {
      //submit the grabHero() API call with Enter Button
      const routeBase = localStorage.getItem("routeBase"); 

      const changeCharacter = this.props.changeCharacter;
      if (e.key === 'Enter') {
        this.props.showCharacterPopup(false); //this turns off the info popup in the featured Appearances area 
        console.log("search: " + this.state.search + " --- Current: "  + currentCharacter);
        //this if() only does an api call if its a new character. Otherwise we just route to 
        //the character page. This was a bug in sectionFeaturedComic.js where it was doing a similar check
        //the showComicArea() was never being called so it would just load forever
        var currentCharacter = currentCharacterInfo.character.toLowerCase();
        var searchedCharacter = this.state.search.toLowerCase();
        if(searchedCharacter != currentCharacter && searchedCharacter != ""){
          getMainCharacterData(this.state.search,this.changeCharacter,this.showComicArea,currentCharacterInfo);
        }
        this.setState({ redirect: true })
        this.props.history.push(routeBase + "/character")  
      }
  
    }//end handleKeyPress()

    searchButtonClick(searchedCharacter,changeCharacter,showComicArea,currentCharacterInfo){
      var currentCharacter = currentCharacterInfo.character.toLowerCase();
      var searchedCharacter = searchedCharacter.toLowerCase();
      //this if() solves the same issue mentioned in handleKeyPress()
      if(searchedCharacter != currentCharacter && searchedCharacter != ""){
        getMainCharacterData(searchedCharacter,changeCharacter,showComicArea,currentCharacterInfo)
      }
    }//end searchButtonClick()


    render(props) {
      const routeBase = localStorage.getItem("routeBase"); 
      var currentCharacterInfo = this.props.characterInfo;

      const inlineStyle = {
        marginBottom:"10px"
      }
      return (
        <div className = "searchBoxWrapper">
            <div className="SearchBoxContainer">
                <input type = "text" className="searchBox" placeholder = "Who would you like me to find Sir? ..."
                    onChange = {this.updateSearchText.bind(this)} 
                    value={this.state.search} 
                    onKeyPress={ (e)=>{this.handleKeyPress(e,currentCharacterInfo)}} 
                />
            </div>
            <Link to={routeBase + "/character"}>
              <button className="searchButton" onClick={()=>this.searchButtonClick(this.state.search,this.changeCharacter,this.showComicArea,currentCharacterInfo)}></button>
            </Link>
        </div>
      );
    }
  }

  export default withRouter(SearchBox);


// WEBPACK FOOTER //
// ./src/components/searchBox/SearchBoxContainer.js